/**
 * ! @description: This is the main component for the training page ( origin of all the sub components )
 */

// Dependencies
import React, { Fragment } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

// CSS
import "../../../css/Training.css";

function Training() {
  const location = useLocation();
  return (
    <Fragment>
      <nav className="navbar navbar-expand-md navbar-light m-2 displayPro">
        <ul className="navbar-nav me-auto mb-lg-0" id="category-underline">
          {/* <li className="nav-item">
            <NavLink
              to="teacher"
              activeClassName="active"
              className="subNav-color"
            >
              Teachers
            </NavLink>
          </li> */}

          {/* <li className="nav-item">
            <NavLink
              to="/lte-session"
              activeclassname="active"
              className={`subNav-color ${location.pathname === "/lte-session" ? "category-active" : "category-deActive" }`}
            >
              Students
            </NavLink>
          </li> */}

          <li className="nav-item">
            <NavLink
              // to="group"
              to="/lte-session"
              activeclassname="active"
              className={`subNav-color ${location.pathname === "/lte-session" ? "category-active" : "category-deActive" }`}
            >
              Training Batch
            </NavLink>
          </li>

           <li className="nav-item">
            <NavLink
              to="training/teachers"
              activeclassname="active"
              className={`subNav-color`}
            >
              Teacher Training Data
            </NavLink>
          </li>
        </ul>
      </nav>

      <Outlet />
    </Fragment>
  );
}

export default Training;
